import React from 'react';
import { X } from 'lucide-react';

const CustomAlert = ({ message, onClose }) => {
  return (
    <div className="fixed top-20 right-4 z-50 max-w-sm w-full">
      <div className="bg-green-100 border-l-4 border-green-500 text-white-700 p-4 rounded-lg shadow-lg flex justify-between items-center">
        <div className="flex-1">
          <p className="font-semibold"></p>
          <p>{message}</p>
        </div>
        <button
          onClick={onClose}
          className="ml-4 p-1 rounded-full hover:bg-green-200 transition-colors"
        >
          <X size={20} />
        </button>
      </div>
    </div>
  );
};

export default CustomAlert;